module.exports = __webpack_public_path__ + "static/media/chat_green.265ca053.svg";